<template>
    <PageLoading :loading="loading">
        <!-- 错误页面 -->
        <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

        <!-- 正常页面 -->
        <div v-else class="class-summary-page">
            <div class="header-cell">
                <!-- 顶部信息区域 -->
                <div class="header-section">
                    <div class="school-info">
                        <div class="school-name">{{ classInfo.school_name }}</div>
                        <div class="class-info">
                            <span class="class-name">{{ classInfo.grade_name }} {{ classInfo.name }}</span>
                            <van-icon name="exchange" class="cycle-icon" @click="showSelectClassModal = true" />
                            <div class="separator"></div>
                            <span class="semester">{{ classInfo.term_name }}</span>
                        </div>
                    </div>
                    <div class="action-buttons">
                        <van-button type="primary" plain class="forward-btn" size="small" icon="wechat" @click="forwardToGroup">
                            转发家长绑定
                        </van-button>
                        <van-button type="primary" plain class="add-btn" size="small" icon="plus"
                            @click="showAddStudentModal = true">
                            添加学生
                        </van-button>
                    </div>
                </div>

                <!-- 统计卡片区域 -->
                <div class="stats-section">
                    <div class="stats-grid">
                        <div class="stat-card total">
                            <div class="stat-label">总人数</div>
                            <div class="stat-number">{{ stats.total_students }}</div>
                        </div>
                        <div class="stat-card registered">
                            <div class="stat-label">已录脸</div>
                            <div class="stat-number">{{ stats.face_collected }}</div>
                        </div>
                        <div class="stat-card unregistered">
                            <div class="stat-label">未录脸</div>
                            <div class="stat-number">{{ stats.face_not_collected }}</div>
                        </div>
                        <div class="stat-card subscribed">
                            <div class="stat-label">已订奶</div>
                            <div class="stat-number">{{ stats.total_orders_student }}</div>
                        </div>
                        <div class="stat-card rate">
                            <div class="stat-label">订奶率</div>
                            <div class="stat-number">{{ stats.order_rate }}%</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tab切换区域 -->
            <div class="tab-section">
                <van-tabs v-model:active="activeTab" class="custom-tabs">
                    <van-tab title="全部学生" name="all">
                        <div class="tab-content">
                            <!-- 空状态 -->
                            <div v-if="classInfo.student_list.length === 0" class="empty-state">
                                <van-empty description="暂无学生" />
                            </div>
                            <!-- 学生列表 -->
                            <div v-else class="student-list">
                                <div class="student-item" v-for="student in classInfo.student_list" :key="student.id">
                                    <div class="student-info">
                                        <div class="student-name">{{ student.name }}</div>
                                        <div class="student-status">
                                            <span class="status-item"
                                                :class="Object.keys(student.face_image_arr || {}).length > 0 ? 'success' : 'error'">
                                                <van-icon :name="Object.keys(student.face_image_arr || {}).length > 0 ? 'success' : 'cross'" />
                                                {{ Object.keys(student.face_image_arr || {}).length > 0 ? '已录脸' : '未录脸' }}
                                            </span>
                                            <span class="status-item"
                                                :class="student.person_identity === '已绑定' ? 'success-milk' : 'error-milk'">
                                                <van-icon
                                                    :name="student.person_identity === '已绑定' ? 'success' : 'cross'" />
                                                {{ student.person_identity }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="student-actions">
                                        <van-button v-if="Object.keys(student.face_image_arr || {}).length == 0" class="face-btn" size="small"
                                            :icon="require('@/assets/icons/face-white.svg')" @click="goToFaceRecognition(student)">
                                            录入人脸
                                        </van-button>
                                        <van-button class="edit-btn" size="small" icon="edit"
                                            @click="openEditStudentModal(student)">
                                            编辑
                                        </van-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-tab>

                    <van-tab title="已订奶" name="subscribed">
                        <div class="tab-content">
                            <!-- 空状态 -->
                            <div v-if="subscribedOrders.length === 0" class="empty-state">
                                <van-empty description="暂无订奶订单" />
                            </div>
                            <!-- 订单列表 -->
                            <div v-else class="order-list">
                                <div class="order-item" v-for="order in subscribedOrders" :key="order.id">
                                    <div class="order-item-header">
                                        <div class="student-name">{{ order.student_name }}</div>
                                        <div class="product-info">
                                            <span class="product-name">{{ order.product_info?.name }}/{{ order.order_cycle_name }}</span>
                                            <!-- <div class="separator"></div>
                                            <span class="period">{{ order.start_send_date }}至{{ order.end_date }}</span> -->
                                        </div>
                                        <div class="product-info">
                                            <span class="period">{{ order.start_send_date }}至{{ order.end_date }}</span>
                                        </div>
                                        <div class="order-status">
                                            <van-tag :color="stateColorMap[order.state][0]" :text-color="stateColorMap[order.state][1]" round
                                                class="order-status-tag">
                                                {{ order.state }}
                                            </van-tag>
                                            <span class="delivery-method">
                                                <!-- :class="order.machine_name ? 'machine' : 'manual'" <van-icon :name="order.machine_name ? require('@/assets/icons/machine.svg') : require('@/assets/icons/people.svg')" /> -->
                                                {{ order.milk_way_info?.name }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="order-price">¥{{ order.order_amount }}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>

                    <van-tab title="刷脸购买" name="face-purchase">
                        <div class="tab-content">
                            <div class="date-filter">
                                <van-field v-model="dateRangeText" placeholder="请选择日期区间" readonly
                                    @click="showCalendar = true" >
                                    <template #right-icon>
                                        <div class="field-icons">
                                            <van-icon v-if="dateRangeText" name="cross" @click.stop="clearDateRange" class="clear-icon" />
                                            <van-icon name="calendar-o" @click="showCalendar = true" class="calendar-icon" />
                                        </div>
                                    </template>
                                </van-field>
                            </div>

                            <!-- 日期选择弹窗 -->
                            <van-calendar v-model:show="showCalendar" type="range" :min-date="minDate" :allow-same-day="true"
                                :max-date="maxDate" @confirm="onDateConfirm" color="#8B0000" />

                            <!-- 空状态 -->
                            <div v-if="rankingList.length === 0" class="empty-state">
                                <van-empty description="暂无购买记录" />
                            </div>
                            <!-- 排行榜 -->
                            <div v-else>
                                <div class="ranking-section">
                                    <div class="ranking-title">购买排行榜</div>
                                    <div class="ranking-list">
                                        <div class="ranking-item" v-for="item in rankingList" :key="item.student_info.id">
                                            <div class="rank-number" :class="{ 'top-three': item.rank < 4 }">{{ item.rank }}
                                            </div>
                                            <van-image round class="student-avatar" fit="cover"
                                                :src="Object.keys(item.student_info.face_image_arr || {}).length > 0 ? 
                                                item.student_info.face_image_arr.face_image_url : userDefaultImage" />
                                            <div class="student-details">
                                                <div class="student-name">{{ item.student_info.name }}</div>
                                                <div class="student-class">{{ item.student_info.class_name }}</div>
                                            </div>
                                            <div class="purchase-amount">¥{{ item.total_amount }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="total-section">
                                    <span class="total-label">合计金额</span>
                                    <span class="total-amount">¥{{ totalAmount }}</span>
                                </div> -->
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </div>

        <!-- 批量添加学生弹框 -->
        <van-popup v-model:show="showAddStudentModal" position="center" round :style="{ width: '90%' }">
            <div class="add-student-modal">
                <div class="modal-header">
                    <span class="modal-title">批量添加学生</span>
                </div>

                <div class="modal-content">
                    <div class="input-label">学生姓名 (每行一个)</div>
                    <van-field v-model="studentNames" type="textarea" placeholder="请输入学生姓名，每行一个学生。最多一次添加10个学生，数量过多请分批添加。" :rows="8" autosize
                        class="student-names-input" />
                    <div class="student-count">已输入{{ studentCount }}个学生</div>
                </div>

                <div class="modal-footer">
                    <van-button class="cancel-btn" @click="showAddStudentModal = false">取消</van-button>
                    <van-button class="confirm-btn" type="primary" @click="confirmAddStudents"
                        :disabled="studentCount === 0">确认添加</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 编辑学生弹框 -->
        <van-popup v-model:show="showEditStudentModal" position="center" round :style="{ width: '90%' }">
            <div class="edit-student-modal">
                <div class="modal-header">
                    <span class="modal-title">请修改学生姓名</span>
                </div>

                <div class="modal-content">
                    <van-field v-model="editingStudentName" placeholder="请输入学生姓名" class="edit-student-input" />
                </div>

                <div class="modal-footer">
                    <van-button class="cancel-btn" @click="showEditStudentModal = false">取消</van-button>
                    <van-button class="confirm-btn" type="primary" @click="confirmEditStudent"
                        :disabled="!editingStudentName.trim()">确认</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 选择班级弹框 -->
        <van-popup v-model:show="showSelectClassModal" position="center" round :style="{ width: '90%' }">
            <div class="select-class-modal">
                <div class="modal-header">
                    <span class="modal-title">选择班级</span>
                </div>

                <div class="modal-content">
                    <!-- 选择学校 -->
                    <div class="select-section">
                        <div class="section-title">学校</div>
                        <!-- @click="showSchoolPicker = true" -->
                        <van-field v-if="selectedClass" v-model="selectedClass.school_name" placeholder="请选择学校" readonly right-icon="arrow" class="select-field" />
                    </div>

                    <!-- 选择年级 -->
                    <div class="select-section">
                        <div class="section-title">年级</div>
                        <div class="grade-grid">
                            <div class="grade-item active" v-if="selectedClass" >
                                {{ selectedClass?.grade_name }}
                            </div>
                            <!-- <div v-for="grade in gradeOptions" :key="grade.id" class="grade-item"
                                :class="{ active: selectedGrade?.id === grade.id }" @click="selectGrade(grade)">
                                {{ grade.name }}
                            </div> -->
                        </div>
                    </div>

                    <!-- 选择班级 -->
                    <div class="select-section">
                        <div class="section-title">选择班级</div>
                        <div class="class-grid">
                            <div v-for="classItem in classOptions" :key="classItem.id" class="class-item"
                                :class="{ active: selectedClass?.id === classItem.id }" @click="selectClass(classItem)">
                                {{ classItem.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <van-button class="cancel-btn" @click="showSelectClassModal = false">取消</van-button>
                    <van-button class="confirm-btn" type="primary" @click="confirmSelectClass">确认</van-button>
                </div>
            </div>
        </van-popup>

        <!-- 学校选择器 -->
        <!-- <SearchablePicker v-model:show="showSchoolPicker" title="选择学校" :options="schoolOptions"
        :value="selectedSchool" value-key="id" display-key="name" @confirm="onSchoolConfirm" @cancel="onSchoolCancel" /> -->
        
    </PageLoading>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { setWxTitle, forwardToFriend, initWxShare } from '@/utils/wx'
import { post } from '@/utils/request'
import { Toast, Dialog } from 'vant'
// import SearchablePicker from '@/components/SearchablePicker.vue'

// 加载状态
const loading = ref(true)
// 用户默认头像
const userDefaultImage = ref(localStorage.getItem('user_default_image'))

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

const activeTab = ref('all')
const showCalendar = ref(false)
const showAddStudentModal = ref(false)
const showEditStudentModal = ref(false)
const showSelectClassModal = ref(false)
// const showSchoolPicker = ref(false)
const startDate = ref('')
const endDate = ref('')
const dateRangeText = ref('')
const studentNames = ref('')
const editingStudentName = ref('')
const currentEditingStudent = ref(null)
// const selectedSchoolName = ref('')
// const selectedSchool = ref(null)
// const selectedGrade = ref(null)
const selectedClass = ref(null)

// 日期范围限制
const minDate = new Date(new Date().getFullYear() - 1, 0, 1)
const maxDate = new Date(new Date().getFullYear() + 1, 11, 31)

// 班级信息
const classInfo = ref({})

// 统计数据
const stats = ref({})

// 学校数据
// const schoolOptions = ref([])

// 年级数据
// const gradeOptions = ref([])

// 班级数据
const classOptions = ref([])

// 已订奶订单数据
const subscribedOrders = ref([])
const stateColorMap = {
    '发货中': ['#FEF9C3', '#CA8A04'],
    '已完结': ['#DCFCE7', '#16A34A'],
}

// 排行榜数据
const rankingList = ref([])

// 处理错误
const handleError = (title, message) => {
    hasError.value = true
    errorTitle.value = title
    errorMessage.value = message
    loading.value = false
}

onMounted(() => {
    setWxTitle('教师专区')
    initPage()
    initWxSDK()
})

// 初始化微信JS-SDK
const initWxSDK = async () => {
    try {
        await initWxShare(this)
    } catch (error) {
        console.error('微信JS-SDK初始化失败:', error)
    }
}

// 页面初始化
const initPage = async () => {
    try {
        // 调用接口获取班级汇总数据
        const params = {
            partner_id: parseInt(localStorage.getItem('userId')),
            company_ids: JSON.parse(localStorage.getItem('company_ids')),
        }
        if (startDate.value && endDate.value) {
            params.start_date = startDate.value
            params.end_date = endDate.value
        }
        if (selectedClass.value) {
            params.class_id = selectedClass.value.id
        }
        const res = await post('/api/statistics/class/order/total', params)
        if (res.result && res.result.state === 'ok') {
            classInfo.value = res.result.selected_class_info
            stats.value = res.result.total_statistics
            subscribedOrders.value = res.result.order_arr || []
            rankingList.value = res.result.retail_ranking || []
            classOptions.value = res.result.class_list || []
            selectedClass.value = res.result.selected_class_info
           if (!startDate.value) dateRangeText.value = `${res.result.start_date} 至 ${res.result.end_date}`
        } else {
            handleError('加载失败', res.result?.message || '接口异常')
        }
    } catch (error) {
        console.error('页面初始化失败:', error)
        handleError('加载失败', '页面加载失败，请重试')
    } finally {
        loading.value = false
    }
}

// 计算属性
// const totalAmount = computed(() => {
//     return rankingList.value.reduce((sum, item) => sum + item.amount, 0)
// })

// 计算学生数量
const studentCount = computed(() => {
    if (!studentNames.value.trim()) return 0
    const names = studentNames.value.split('\n').filter(name => name.trim())
    return names.length
})

// 日期确认处理函数
const onDateConfirm = async (values) => {
    const [start, end] = values
    startDate.value = formatDate(start)
    endDate.value = formatDate(end)
    dateRangeText.value = `${startDate.value} 至 ${endDate.value}`
    showCalendar.value = false

    initPage()
}

// 清空日期区间
const clearDateRange = async () => {
    startDate.value = ''
    endDate.value = ''
    // 重新加载数据，不传日期参数
    await initPage()
    dateRangeText.value = ''
}

// 格式化日期
const formatDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

// 确认添加学生
const confirmAddStudents = async () => {
    if (!studentNames.value.trim()) {
        Toast('请输入学生姓名')
        return
    }

    const names = studentNames.value.split('\n').filter(name => name.trim())

    try {
        const res = await post('/api/add/child/student', {
            partner_id: parseInt(localStorage.getItem('userId')),
            type: '班级',
            name: names,
            class_id: selectedClass.value?.id,
            grade_id: selectedClass.value?.grade_id,
            school_id: selectedClass.value?.school_id,
        })

        if (res.result && res.result.state === 'ok') {
            Toast.success('添加成功')
            studentNames.value = ''
            showAddStudentModal.value = false
            // 重新加载数据
            initPage()
        } else {
            Dialog.alert({
                title: '添加失败',
                message: res.result?.message || '接口异常'
            })
        }
    } catch (error) {
        console.error('添加学生失败:', error)
        Dialog.alert({
            title: '添加失败',
            message: '网络错误，请重试'
        })
    }
}

// 显示编辑学生弹框
const openEditStudentModal = (student) => {
    currentEditingStudent.value = student
    editingStudentName.value = student.name
    showEditStudentModal.value = true
}

// 确认编辑学生
const confirmEditStudent = async () => {
    if (!editingStudentName.value.trim()) {
        Toast('请输入学生姓名')
        return
    }

    try {
        const res = await post('/api/add/child/student', {
            partner_id: parseInt(localStorage.getItem('userId')),
            student_id: currentEditingStudent.value.id,
            name: editingStudentName.value.trim(),
            type: '班主任',
        })

        if (res.result && res.result.state === 'ok') {
            Toast.success('修改成功')
            // 更新本地状态
            currentEditingStudent.value.name = editingStudentName.value.trim()
            editingStudentName.value = ''
            currentEditingStudent.value = null
            showEditStudentModal.value = false
        } else {
            Dialog.alert({
                title: '修改失败',
                message: res.result?.message || '接口异常'
            })
        }
    } catch (error) {
        console.error('修改学生失败:', error)
        Dialog.alert({
            title: '修改失败',
            message: '网络错误，请重试'
        })
    }
}

// 学校选择器确认
// const onSchoolConfirm = (school) => {
//     selectedSchool.value = school
//     selectedSchoolName.value = school.name
//     gradeOptions.value = school.common_grade_arr || []
//     showSchoolPicker.value = false
// }

// // 学校选择器取消
// const onSchoolCancel = () => {
//     showSchoolPicker.value = false
// }

// 年级选择器确认
// const selectGrade = (grade) => {
//     selectedGrade.value = grade
//     classOptions.value = grade.class_arr || []
// }

// 班级选择器确认
const selectClass = (classItem) => {
    selectedClass.value = classItem
}

// 确认选择班级
const confirmSelectClass = async () => {
    showSelectClassModal.value = false
    initPage()
}

// 转发到群
const forwardToGroup = () => {
    
    forwardToFriend({
        title: '班级订奶',
        desc: '关爱孩子健康成长，从每天一杯牛奶开始！',
        link: `${window.location.origin}/bind-student?class_id=${selectedClass.value?.id}`,
        success: () => {
            Toast('请点击右上角分享给好友')
        },
        fail: () => {
            Toast('转发失败，请重试')
        }
    })
}

const goToFaceRecognition = (student) => {
    window.location.href = '/face-recognition?partner_id=' + student.id
}


</script>

<style scoped>
.class-summary-page {
    background: #fff;
    min-height: calc(100vh - 16px);
    padding: 8px;
}

.header-cell {
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
}

/* 顶部信息区域 */
.header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.school-info {
    flex: 1;
}

.school-name {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 8px;
    line-height: 1.2;
}

.class-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #6B7280;
}

.cycle-icon {
    margin: 0 8px;
    color: var(--van-primary-color);
    font-size: 16px;
    font-weight: 500;
}

.separator {
    width: 1px;
    height: 12px;
    background: #6B7280;
    margin-right: 8px;
}

.semester {
    color: #6b7280;
    font-weight: 400;
}

.action-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.forward-btn,
.add-btn {
    border-radius: 8px;
}

/* 统计卡片区域 */
.stats-section {
    padding: 16px 0 8px 0;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.stat-card {
    border-radius: 8px;
    padding: 12px;
    height: 52px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.stat-number {
    font-size: 18px;
    font-weight: 500;
}

.stat-label {
    font-size: 14px;
    color: #6B7280;
    margin-bottom: 8px;
}

.total {
    background: #FEF2F2;
}

.total .stat-number {
    color: var(--van-primary-color);
}

.registered {
    background: #F0FDF4;
}

.registered .stat-number {
    color: #16A34A;
}

.unregistered {
    background: #FEFCE8;
}

.unregistered .stat-number {
    color: #CA8A04;
}

.subscribed {
    background: #EFF6FF;
}

.subscribed .stat-number {
    color: #2563EB;
}

.rate {
    background: #FAF5FF;
}

.rate .stat-number {
    color: #9333EA;
}

/* Tab区域 */
.tab-section {
    margin: 14px 0;
}

.custom-tabs {
    --van-tabs-nav-background: transparent;
}

.tab-content {
    padding: 14px 0;
}

/* 学生列表样式 */
.student-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.student-item {
    background: #F9FAFB;
    border-radius: 8px;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.student-info {
    flex: 1;
}

.student-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 6px;
}

.student-status {
    display: flex;
    gap: 8px;
}

.status-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    padding: 2px 6px;
    border-radius: 8px;
}

.status-item.success {
    color: #16A34A;
    background: #F0FDF4;
}

.status-item.error {
    color: #CA8A04;
    background: #FEFCE8;
}

.status-item.success-milk {
    color: #2563EB;
    background: #EFF6FF;
}

.status-item.error-milk {
    color: #9CA3AF;
    background: #f3f7fd;
}

.student-actions {
    display: flex;
    gap: 8px;
}

.action-btn {
    font-size: 12px;
    height: 28px;
    padding: 0 8px;
    border-radius: 4px;
}

.face-btn {
    background: #3B82F6;
    color: #FFFFFF;
    border-radius: 4px;
    border: none;
}

.edit-btn {
    background: #F3F4F6;
    color: #4B5563;
    border-radius: 4px;
    border: none;
}

/* 订单列表样式 */
.order-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.order-item {
    background: #F9FAFB;
    border-radius: 8px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.order-price {
    font-size: 16px;
    font-weight: 600;
    color: var(--van-primary-color);
}

.product-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #6B7280;
}

.product-name {
    margin-right: 8px;
}

.order-status {
    display: flex;
    align-items: center;
    gap: 8px;
}

.order-status-tag {
    font-size: 12px;
    padding: 3px 8px;
}

.delivery-method {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #4071DE;
}

.delivery-method.machine {
    color: #2563EB;
}

.delivery-method.manual {
    color: #16A34A;
}

/* 刷脸购买页面样式 */
.date-filter {
    margin-bottom: 16px;
}

.date-filter .van-field {
    background: #f9fafb;
    border-radius: 8px;
    padding: 12px;
}

.date-filter :deep(.van-field__control) {
    text-align: center;
}

.ranking-section {
    margin-bottom: 16px;
}

.ranking-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
}

.ranking-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.ranking-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background: #f9fafb;
    border-radius: 8px;
}

.rank-number {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    color: #9CA3AF;
}

.rank-number.top-three {
    color: var(--van-primary-color);
}

.student-avatar {
    width: 40px;
    height: 40px;
}

.student-details {
    flex: 1;
}

.student-details .student-name {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 2px;
}

.student-details .student-class {
    font-size: 14px;
    color: #6B7280;
}

.purchase-amount {
    font-size: 16px;
    font-weight: 500;
    color: var(--van-primary-color);
}

.total-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: #f9fafb;
    border-radius: 8px;
}

.total-label {
    font-size: 16px;
    color: #4B5563;
}

.total-amount {
    font-size: 20px;
    font-weight: 500;
    color: var(--van-primary-color);
}

/* 批量添加学生弹框样式 */
.add-student-modal {
    padding: 25px 21px;
}

.modal-header {
    margin-bottom: 28px;
}

.modal-title {
    font-size: 18px;
}

.modal-content {
    margin-bottom: 20px;
}

.input-label {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 8px;
}

.student-names-input {
    margin-bottom: 12px;
    padding: 0;
}

.student-names-input :deep(.van-field__control) {
    min-height: 120px;
    padding: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.5;
}

.student-count {
    font-size: 12px;
    color: #9ca3af
}

.modal-footer {
    display: flex;
    gap: 12px;
}

.cancel-btn {
    flex: 1;
    background: #f3f4f6;
    color: #6b7280;
    border: none;
    border-radius: 6px;
    height: 40px;
}

.confirm-btn {
    flex: 1;
    border: none;
    border-radius: 6px;
    height: 40px;
}

/* 编辑学生弹框样式 */
.edit-student-modal {
    padding: 25px 21px;
}

.edit-student-input {
    padding: 0;
}

.edit-student-input :deep(.van-field__control) {
    padding: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    font-size: 14px;
    min-height: 44px;
}

/* 选择班级弹框样式 */
.select-class-modal {
    padding: 20px;
}

.select-section {
    margin-bottom: 20px;
}

.section-title {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 8px;
}

.search-field {
    margin-bottom: 12px;
}

.search-field :deep(.van-field__control) {
    background: #f9fafb;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
}

.grade-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.grade-item {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;
    color: #374151;
    background: #f3f4f6;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
}

.grade-item.active {
    background: var(--van-primary-color);
    color: white;
}

.class-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.class-item {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;
    color: #374151;
    background: #f3f4f6;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
}

.class-item.active {
    background: var(--van-primary-color);
    color: white;
}

.empty-state :deep(.van-empty) {
    padding: 0;
}

/* 日期选择器图标样式 */
.field-icons {
    display: flex;
    align-items: center;
    gap: 8px;
}

.calendar-icon {
    font-size: 18px;
    color: #6b7280;
    cursor: pointer;
    transition: color 0.2s;
}
.clear-icon {
    font-size: 16px;
    color: #9ca3af;
    cursor: pointer;
    transition: color 0.2s;
    padding: 2px;
}

</style>